import { SEAT_CIRCLE_DIAMETER, SEAT_CIRCLE_RADIUS, SEAT_SPACING, STROKE_WIDTH } from '../../constants';
import { ceil } from '../../utils/utils';
export const useTable = (props) => {
    const { definition } = props;
    const { width, height, layout: [topSeatAmount, rightSeatAmount, bottomSeatAmount, leftSeatAmount], } = definition;
    const seatsReservedSize = SEAT_CIRCLE_DIAMETER + SEAT_SPACING;
    const totalSeatsSize = seatsReservedSize * 2;
    const totalBorderSize = STROKE_WIDTH * 2;
    const rectWidth = Math.max(width - totalSeatsSize + totalBorderSize, 0);
    const rectHeight = Math.max(height - totalSeatsSize + totalBorderSize, 0);
    const topSeatsOverflow = getAllowedContainerOverflow(width, rectWidth, topSeatAmount);
    const topSeatsWidth = rectWidth + topSeatsOverflow;
    const topSeatsHeight = SEAT_CIRCLE_DIAMETER;
    const topSeatsX = seatsReservedSize - ceil(topSeatsOverflow / 2);
    const topSeatsY = 1;
    const rightSeatsOverflow = getAllowedContainerOverflow(height, rectHeight, rightSeatAmount);
    const rightSeatsWidth = SEAT_CIRCLE_DIAMETER;
    const rightSeatsHeight = rectHeight + rightSeatsOverflow;
    const rightSeatsX = seatsReservedSize + rectWidth + SEAT_SPACING - 1;
    const rightSeatsY = seatsReservedSize - ceil(rightSeatsOverflow / 2);
    const rightLabelIndexOffset = topSeatAmount;
    const bottomSeatsOverflow = getAllowedContainerOverflow(width, rectWidth, bottomSeatAmount);
    const bottomSeatsWidth = rectWidth + bottomSeatsOverflow;
    const bottomSeatsHeight = SEAT_CIRCLE_DIAMETER;
    const bottomSeatsX = seatsReservedSize - ceil(bottomSeatsOverflow / 2);
    const bottomSeatsY = seatsReservedSize + rectHeight + SEAT_SPACING - 1;
    const bottomLabelIndexOffset = topSeatAmount + rightSeatAmount;
    const leftSeatsOverflow = getAllowedContainerOverflow(height, rectHeight, leftSeatAmount);
    const leftSeatsWidth = SEAT_CIRCLE_DIAMETER;
    const leftSeatsHeight = rectHeight + leftSeatsOverflow;
    const leftSeatsX = 1;
    const leftSeatsY = seatsReservedSize - ceil(leftSeatsOverflow / 2);
    const leftLabelIndexOffset = topSeatAmount + rightSeatAmount + bottomSeatAmount;
    return {
        seatsReservedSize,
        rectWidth,
        rectHeight,
        topSeatAmount,
        topSeatsWidth,
        topSeatsHeight,
        topSeatsX,
        topSeatsY,
        rightSeatAmount,
        rightSeatsWidth,
        rightSeatsHeight,
        rightSeatsX,
        rightSeatsY,
        rightLabelIndexOffset,
        bottomSeatAmount,
        bottomSeatsWidth,
        bottomSeatsHeight,
        bottomSeatsX,
        bottomSeatsY,
        bottomLabelIndexOffset,
        leftSeatAmount,
        leftSeatsWidth,
        leftSeatsHeight,
        leftSeatsX,
        leftSeatsY,
        leftLabelIndexOffset,
    };
};
const getAllowedContainerOverflow = (totalSize, containerSize, seatAmount) => {
    const emptySpace = containerSize - seatAmount * SEAT_CIRCLE_RADIUS * 2;
    if (emptySpace >= 0) {
        return 0;
    }
    // We do not want vertical and horizontal seats to overlap
    const minDistanceFromSide = ceil(Math.sqrt(2 * Math.pow(SEAT_CIRCLE_RADIUS, 2)));
    const additionalSpace = 2;
    const overflow = totalSize - minDistanceFromSide * 2 - containerSize - additionalSpace;
    if (overflow < 0) {
        return 0;
    }
    return overflow;
};
//# sourceMappingURL=use-table.js.map